/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Notes/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Notes({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Notes",
  onChange,
  isInvalid,
  onSubmit
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonNoteNoteValueData = fromData.useDataValue({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.person.note.note',
})
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonNoteNoteChangeData = fromData.useDataChange({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.person.note.note',
})
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonNoteNoteSubmitData = fromData.useDataSubmit({ viewPath,
context: 'edit_professional',
})
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 marginBottom={dtSpaceL}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Notes"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 data="edit_professional.employee.provider.employee_resource.employment_contract.person.note.note"
 placeholder="Notes"
 onChange={editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonNoteNoteChangeData}
 value={editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonNoteNoteValueData}
 isInvalid={!undefined}
 onSubmit={editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonNoteNoteSubmitData}
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}